import { InjectionToken } from '@angular/core';
import { OrdersRow } from '../interface';

export const ORDER_LINK = new InjectionToken<(order: OrdersRow) => string>('SALES_ORDERS_TABLE_ORDER_LINK', {
  providedIn: 'root',
  factory: () => (order: OrdersRow) => `/order-management/${order.businessId}/info/${order.orderId}`,
});
